import React, { useEffect, useState } from "react";
import {
  Form,
  Title,
  Input,
  Button,
  ModalOverlay,
  ModalContent,
  CloseButton,
  InputWrapper,
} from "./style"; // Styled components
import { toast } from "react-toastify";
import { authHeader } from "../helper/authHeader";
import logoImg from "../assets/logo/Logo.png";

const ProfileModal = ({ isOpen, onClose, userProfile, setUserProfile }) => {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
  });

  // Fetch profile data from the API when the modal is opened
  useEffect(() => {
    if (isOpen) {
      const fetchProfile = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_URL}/profile`, {
            method: "GET",
            headers: authHeader(true),
          });

          if (!response.ok) {
            throw new Error("Failed to fetch profile data");
          }

          const data = await response.json();

          // Update profile state with the fetched data (name, email)
          setProfile({
            name: data.user.name || "",
            email: data.user.email || "",
          });
        } catch (error) {
          console.error("Error fetching profile data:", error);
          toast.error("Failed to fetch profile data");
        }
      };

      fetchProfile();
    }
  }, [isOpen, userProfile.token]); // Fetch only when modal opens and token is available

  // Handle profile form changes
  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  // Handle profile update submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new URLSearchParams();
      formData.append("name", profile.name);
      formData.append("email", profile.email);

      const response = await fetch(`${process.env.REACT_APP_URL}/profile`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${userProfile.token}`, // Use dynamic token
          "Content-Type": "application/x-www-form-urlencoded", // URL-encoded data
        },
        body: formData.toString(),
      });

      const data = await response.json();

      if (response.ok) {
        // Update the parent component's userProfile state with the new data
        setUserProfile({
          ...userProfile,
          user: {
            ...userProfile.user,
            name: profile.name,
            email: profile.email,
          },
        });
        toast.success("Profile updated successfully!");
        onClose(); // Close modal on success
      } else {
        toast.error(
          data.message || "An error occurred while updating the profile."
        );
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Error while updating the profile.");
    }
  };

  // Early return if modal is not open
  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Form onSubmit={handleSubmit}>
          <Title>
            <img width={200} src={logoImg} alt="logo" />
          </Title>

          <InputWrapper>
            <Input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleChange}
              required
            />
          </InputWrapper>
          <InputWrapper>
            <Input
              type="email"
              name="email"
              value={profile.email}
              onChange={handleChange}
              required
            />
          </InputWrapper>
          <Button type="submit">Save</Button>
        </Form>
      </ModalContent>
    </>
  );
};

export default ProfileModal;
